<template>
  <custom-dialog :title="model.title" width="600px" :visible="visible" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body batch-republish-version">
      <div class="publish-container">
        <div class="publish-list">
          <el-table :data="model.data" height="100%">
            <el-table-column prop="protocolName" :label="$t('dms_batch_republish_version_dialog.xie_yi')"></el-table-column>
            <el-table-column :label="$t('Common.com_status')" fixed="right" width="150">
              <template slot-scope="scope">
                <el-button :type="getStatusType(scope.$index)">{{ getStatusName(scope.$index) }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {
    list: Array,
  },
  data() {
    return {
      index: 0,
      isError: false,
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    async init() {
      try {
        const list = this.model.data;
        for (const item of list) {
          const version = item.tcpVersion;
          const protocolId = item.protocolId;
          const url = `${apis.ProtocolPublishPublish}/${protocolId}/${version}`;
          await this.$postJSON(url);
          this.index++;
        }
        const tips = this.$t('dms_batch_republish_version_dialog.nxzdogxyycgfb', [list.length]);
        this.$message({
          type: 'success',
          message: tips,
        });
        setTimeout(async () => {
          this.$emit('success');
          this.$emit('close');
        }, 3000);
      } catch (e) {
        this.$message({
          type: 'error',
          message: this.$t('dms_batch_republish_version_dialog.fa_bu_shi_bai'),
        });
        this.isError = true;
        setTimeout(async () => {
          this.$emit('fail');
          this.$emit('close');
        }, 5000);
      }
    },
    getStatusName(index) {
      if (index === this.index) {
        if (this.isError) {
          return this.$t('dms_batch_republish_version_dialog.fa_bu_shi_bai');
        }
        return this.$t('dms_batch_republish_version_dialog.zheng_zai_fa_bu');
      }
      if (index < this.index) {
        return this.$t('dms_batch_republish_version_dialog.fa_bu_wan_cheng');
      }

      return this.$t('dms_batch_republish_version_dialog.dai_fa_bu');
    },
    getStatusType(index) {
      if (index === this.index) {
        if (this.isError) {
          return 'danger';
        }
        return 'primary';
      }
      if (index < this.index) {
        return 'success';
      }
      return '';
    },
  },
  created() {},
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
.batch-republish-version {
  .publish-container {
    width: 100%;
    height: 400px;
    margin: auto;
    background: #fff;
    display: flex;
    flex-direction: column;

    > .title {
      text-align: center;
      font-weight: bold;
      font-size: 20px;
      line-height: 50px;
    }

    .publish-list {
      flex: 1;
      height: 0;
      .pass {
        color: #16d071;
      }
      .processing {
        color: #35b8e0;
      }
      .error {
        color: #ff5c5b;
      }
    }
  }
}
</style>
